import getAuthCookie from "../auth/getAuthCookie";
import config from "../config/config-server";

const verifySession = async () => {
    const API_VERIFY_SESSION = `${config.apiUrl}/api/auth`;

    const token = getAuthCookie('token');

    if (token === null || token === undefined) {
        const data = { message: 'NOT_SESSION' }
        return data;
    } else {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        const res = await fetch(API_VERIFY_SESSION, {
            method: 'POST',
            headers: headers
        })

        const dataSession = await res.json();

        return dataSession;
    }

}

export default verifySession;